import { render } from "./InboundCallsChart.vue?vue&type=template&id=3ad15f81&ts=true"
import script from "./InboundCallsChart.vue?vue&type=script&lang=ts"
export * from "./InboundCallsChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__